import { ChangeDetectionStrategy, Component, ViewChild, ViewContainerRef } from "@angular/core";
import { QUESTION_1_ANSWERS, QUESTION_2_ANSWERS, QUESTION_3_ANSWERS, QUESTION_4_ANSWERS, QUESTION_5_ANSWERS } from "../../models/questionnaire-settings.model";
import { NgFor, NgIf } from "@angular/common";
import { UrlBuilderService } from "../../services/url-builder.service";

import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import { Store } from "@ngrx/store";
import { updateSchoolDetails } from "../../store/platform.actions";
import { OchPopupModalComponent } from "../../shared/och-popup-modal/och-popup-modal.component";
import {environment} from '../../../environments/environment';
import {TrackingService} from '../../services/tracking.service';

type Question = {
    id: string;
    type: string;
    text: string;
    placeholder?: string;
    subText?: string;
    options: Array<any>
}

@Component({
    selector: 'questionnaire',
    templateUrl: './questionnaire.component.html',
    styleUrls: ['./questionnaire.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        OchPopupModalComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
  })
  export class QuestionnaireComponent {
    // @ViewChild('modal') modal: ViewContainerRef;

    title = "All set! Before we start, help us improve your experience."

    questions: Question[]
    mascotOwlUrl: string
    finishedOwlMascot: string;

    answers = {
        answered: false,
        question1Answer: null,
        question2Answer: null,
        question3Answer: null,
        question4Answer: null,
        question5Answer: null
    }

    visibility = {
        question1Answer: true,
        question2Answer: false,
        question3Answer: false,
        question4Answer: false,
        question5Answer: false
    }
    finishBtnVisible = false

    questionnaireCompleted = false

    constructor(
        private urlBuilder: UrlBuilderService,
        private store: Store,
        private tracking: TrackingService) {
      }

      ngOnInit()
      {
        this.mascotOwlUrl = this.urlBuilder.buildImageUrl(
            "images/course-page/icons/och-owl-mascot.png"
          );

        this.finishedOwlMascot = this.urlBuilder.buildImageUrl(
          "images/course-page/icons/finished-owl-mascot.jpg"
        );

        this.questions = [
            {
                id: "question1Answer",
                type: 'radio',
                text: "What do you want to achieve with OnlineCourseHost.com?",
                options: this.convertToLabelAndValue(QUESTION_1_ANSWERS)
            },
            {
                id: 'question2Answer',
                type: "radio",
                text: "Are you currently teaching online?",
                options: this.convertToLabelAndValue(QUESTION_2_ANSWERS)
            },
            {
                id: 'question3Answer',
                type: "radio",
                text: "What is the size of your audience?",
                subText: "(email contacts, subscribers, social media following etc.)",
                options: this.convertToLabelAndValue(QUESTION_3_ANSWERS)
            },
            {
                id: 'question4Answer',
                type: "dropdown",
                text: "What is your industry?",
                placeholder: "Select your industry",
                options: this.convertToLabelAndValue(QUESTION_4_ANSWERS)
            },
            {
                id: 'question5Answer',
                type: "dropdown",
                placeholder: "Select your role",
                text: "What best describes your role?",
                options: this.convertToLabelAndValue(QUESTION_5_ANSWERS)
            }
        ]

    }

    convertToLabelAndValue(obj: Object) {
        return Object.keys(obj).map(key => {
            return { value: obj[key], label: obj[key] }
        })
    }

    onSelectionChange(event: any, question) {
        // this.answers[question.id] = event.value?.value

        // this.finishBtnVisible = true
        this.selectOption(question, event.value)
    }

    selectOption(question, option) {
        this.visibility[question.id] = false
        // make the bext one to be visible
        const nextQuestion = this.questions.find(q => q.id === question.id)
        const nextQuestionIndex = this.questions.indexOf(nextQuestion) + 1
        if (nextQuestionIndex < this.questions.length) {
            this.visibility[this.questions[nextQuestionIndex].id] = true
        }

        this.answers[question.id] = option.value

        // show button if its the last question
        if (nextQuestionIndex === this.questions.length) {
            this.finishBtnVisible = true
        }
    }

    isFormValid() {
        return Object.keys(this.answers).filter(answer => answer !== "answered").every(key => this.answers[key])
    }

    finish() {
        this.answers.answered = true
        this.questionnaireCompleted = true
        this.title = ""
    }

    done() {
        this.store.dispatch(updateSchoolDetails({
            changes: {
                questionnaireSettings: this.answers
            }
        }))
    }
  }
